module.exports = __webpack_public_path__ + "static/media/joystick.f14df885.svg";